// extracted by mini-css-extract-plugin
export default {"wrapper":"Q4-z","play":"R4-z"};